import React, { forwardRef } from 'react';
import PortalElement from './PortalElement';
import { eventBits } from '../../../utils/portalEvent';

/**
 * The linked event on the card, in one of the eleven shared styles. `event` is any event row
 * the app holds (a search row, a `fromEvent`, the reel's `sourceEvent`); the bits it prints are
 * derived once here.
 */
const PortalEvent = forwardRef(function PortalEvent({ event, layout, linkTo = null, ...rest }, ref) {
  const bits = eventBits(event);
  if (!bits?.title) return null;
  return (
    <PortalElement
      ref={ref}
      kind="event"
      style={layout.eventStyle}
      data={bits}
      pos={layout.event}
      rot={layout.rot?.event}
      scl={layout.scl?.event}
      href={linkTo === undefined ? bits.href : linkTo}
      {...rest}
    />
  );
});

export default PortalEvent;
